// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#profileInvoicePage table th{font-weight:600}", "",{"version":3,"sources":["webpack://./resources/frontend/js/pages/profileInvoicesPage/profileInvoicesPage.scss"],"names":[],"mappings":"AAEI,6BACE,eADN","sourcesContent":["#profileInvoicePage {\n  table {\n    th {\n      font-weight: 600;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
